import Tab from '@mui/material/Tab';
import React from 'react';
import { useStylesTab } from './styles';

function StageHeaderTab(props) {
    const classes = useStylesTab();

    return (
        <Tab
            {...props}
            classes={{
                root: classes.root,
                selected: classes.selected,
                textColorInherit: classes.textColorInherit,
            }}
            textColor="inherit"
        >
            {props.children}
        </Tab>
    );
}

export default StageHeaderTab;
